import { t } from "@lingui/core/macro";

type ExecutionWaitRun = { status: string; executionWaitReason?: string | null } | null | undefined;

export function executionWaitLabel(run: ExecutionWaitRun): string | null {
  if (run?.executionWaitReason === "uncertain_effect")
    return t`Paused: the result of an external action needs checking`;
  if (run?.status !== "queued") return null;
  switch (run.executionWaitReason) {
    case "capacity":
      return t`Waiting for an execution slot`;
    case "computer":
      return t`Waiting for the computer`;
    case "retry":
      return t`Preparing to retry`;
    case "recovery":
      return t`Recovering interrupted work`;
    default:
      return null;
  }
}

/** Capacity is ordinary work in chat; detailed execution views retain its label.
 * У чаті місткість є звичайною роботою; подробиці виконання зберігають цей підпис. */
export function chatExecutionWaitLabel(run: ExecutionWaitRun): string | null {
  return run?.executionWaitReason === "capacity" ? null : executionWaitLabel(run);
}
